import { isEmpty } from 'lodash-es';
import { getBusinessUnit, IInviteStatus, IUserRole, IWorkspaceUserFilter } from 'wisestep-api';
import { IFilterList, WsSelectObj } from 'wisestep-base';

import { IBreadCrumbsList } from '../../../components/WsBreadCrumbs';
import { defaultRoles } from '../../accessControl/AddRoleAccessControl';
import { ICheckBoxListOptions } from '../../jobs/assign/components/AssignedRecruiters';

export const inviteDefaultValues = {
  invitedUsers: [],
  role: IUserRole.RECRUITER,
  downloadAccess: false,
};

export const workspaceUsersPayload: IWorkspaceUserFilter = {
  roles: [],
  statuses: ['activated'],
  userIds: [],
  page: 0,
  size: 20,
  sortBy: 'user_id',
  sortOrder: 'asc',
};

export const workspaceAccountManagerPayload: IWorkspaceUserFilter = {
  roles: [IUserRole.ACCOUNT_MANAGER],
  statuses: ['activated'],
  userIds: [],
  page: 0,
  size: 20,
  sortBy: 'user_id',
  sortOrder: 'asc',
};

export const statusOptions: WsSelectObj[] = [
  {
    label: 'All',
    value: 'all',
  },
  {
    label: 'Activated',
    value: 'activated',
  },
  {
    label: 'Deactivated',
    value: 'deactivated',
  },
  {
    label: 'Invited',
    value: 'invited',
  },
];

export const pushUsersFilters = (data: IWorkspaceUserFilter, dashboards?: boolean) => {
  const filtersArray: IFilterList[] = [];
  if (!isEmpty(data.roles))
    filtersArray.push(
      dashboards
        ? { tag: `${data.roles}`, id: 'roles' }
        : { tag: `Roles: ${data.roles}`, id: 'roles' }
    );
  if (!isEmpty(data.statuses)) {
    filtersArray.push(
      dashboards
        ? { tag: `${data.statuses}`, id: 'statuses' }
        : { tag: `Status: ${data.statuses}`, id: 'statuses' }
    );
  }
  return filtersArray;
};

export const getUsersRolesCheckBoxOptions = () => {
  const rolesCheckBoxList: ICheckBoxListOptions = {};
  defaultRoles.forEach((role) => (rolesCheckBoxList[role.label] = role.value as string));
  return rolesCheckBoxList;
};

export const getUserStatus = (user) =>
  user.barred
    ? IInviteStatus.DEACTIVATED
    : user.accepted
    ? IInviteStatus.ACTIVATED
    : user.invited
    ? IInviteStatus.INVITED
    : 'Invalid';

export const stringToColor = (string: string) => {
  let hash = 0;
  let i;

  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }

  return color;
};

export const stringAvatar = (name: string, index?: number) => {
  return {
    sx: {
      bgcolor:
        index !== undefined
          ? ['#F6EBD0', '#FDC9D0', '#BBF2EF', '#CAF0F8'][index]
          : stringToColor(name),
      color: 'common.black',
      width: 30,
      height: 30,
      fontSize: 15,
    },
    children: `${name.split(' ')[0][0]}`,
  };
};

export const fetchAllBusinessUnits = async () => {
  try {
    const response = await getBusinessUnit();
    return response.data;
  } catch (error) {
    console.error('Error fetching business units:', error);
    throw error;
  }
};

export const mapBusinessUnitIdsToNames = (businessUnitIds, businessUnits) => {
  return businessUnitIds?.map((id) => {
    const businessUnit = businessUnits.find((unit) => unit.id === id);
    return businessUnit ? { id: businessUnit.id, name: businessUnit.name } : null;
  });
};

export enum IDashBoardBreadCrumbTypes {
  TEAMS = '',
  USERS = '/users-list',
  ACCOUNT_MANAGERS = '/account-managers',
  DELIVERY_UNITS = '/organizational-unit-recruitment',
  ACCOUNT_MANAGER_UNITS = '/account-manager-units',
  CLIENT_UNITS = '/client-units',
  CLIENT_CONTACT_UNITS = '/client-contacts-units',
  BUSINESS_UNITS = '/bussiness-units',
  YOUR_DASHBOARDS = '/your-dashboards',
  MASTER_DASHBOARDS = '/master-dashboards',
}

export const getDashBoardBreadCrumbList = (
  type: IDashBoardBreadCrumbTypes,
  label: string
): IBreadCrumbsList[] => [
  { label: 'Dashboards', url: `/workspace-users-and-teams${type}` },
  getBreadCrumbWithLabel(label),
];

export const getBreadCrumbWithLabel = (label: string): IBreadCrumbsList => {
  return { label: label, url: `${window.location.pathname}${window.location.search}` };
};
